export default __webpack_public_path__ + "static/media/heart.db4f76e4.svg";